// extracted by mini-css-extract-plugin
export default {"advantages":"advantages_advantages__qx7U4"};